import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=3f107fd5"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"
import style0 from "./Approve.vue?vue&type=style&index=0&id=3f107fd5&prod&lang=css"
import style1 from "./Approve.vue?vue&type=style&index=1&id=3f107fd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports